import React, { useState } from "react";
import { toast } from "sonner";
import { Smile, Meh, Moon } from "lucide-react";
import api, { formatApiErrorDetail } from "../lib/api";

export const OUTCOMES = [
  { key: "liked", label: "Liked it", icon: Smile, cls: "bg-sorted-sage" },
  { key: "tried", label: "Tried it", icon: Meh, cls: "bg-sorted-blush" },
  { key: "not_today", label: "Not today", icon: Moon, cls: "bg-[#FAD9CE]" },
];

export default function KidsFeedback({ kids, activeId, food, mealTitle = "", onLogged }) {
  const [logged, setLogged] = useState({});

  const log = async (kid, outcome) => {
    try {
      await api.post("/wins", { household_id: activeId, member_id: kid.id, food, outcome, meal_title: mealTitle });
      setLogged({ ...logged, [kid.id]: outcome });
      onLogged?.();
      toast.success(outcome === "not_today" ? `No worries — ${kid.name} will get there ❤️` : `Little win for ${kid.name}! 🎉`);
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  return (
    <div className="space-y-2">
      {kids.map((kid) => (
        <div key={kid.id} className="bg-white rounded-3xl border-2 border-[#FDECEF] p-3 shadow-soft" data-testid={`kid-feedback-${kid.id}`}>
          <p className="font-heading font-semibold text-sorted-ink text-sm mb-2">{kid.name}</p>
          <div className="grid grid-cols-3 gap-2">
            {OUTCOMES.map((o) => (
              <button key={o.key} onClick={() => log(kid, o.key)} data-testid={`kid-${kid.id}-${o.key}`}
                className={`rounded-2xl py-2.5 flex flex-col items-center gap-1 text-xs font-bold border-2 transition-colors ${logged[kid.id] === o.key ? `${o.cls} border-transparent text-sorted-ink` : "bg-white border-[#FDECEF] text-sorted-slate"}`}>
                <o.icon size={18} strokeWidth={2.5} /> {o.label}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
